<div *kienePermission="[1691]" style="padding: 24px" [attr.data-cy]="'aia_kiene_permission_1691'">
    <mat-card [attr.data-cy]="'maaaa_mat-card_1_11_'">
        <div class="one-row">
            <h1 [attr.data-cy]="'maaaa_h1_1_4_'">Anwendungen</h1>
            <span class="spacer" [attr.data-cy]="'maaaa_span_1_16_'"></span>
            <div class="one-row">
                <span class="spacer" [attr.data-cy]="'maaaa_span_2_16_'"></span>
                <button
                    *kienePermission="[1293]"
                    mat-icon-button
                    color="accent"
                    (click)="add()"
                    [attr.data-cy]="'aia_button_1_0_'"
                >
                    <mat-icon [attr.data-cy]="'maaaa_mat-icon_1_2_'">add</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="reload()" [attr.data-cy]="'aia_button_2_0_'">
                    <mat-icon [attr.data-cy]="'maaaa_mat-icon_2_2_'">refresh</mat-icon>
                </button>
            </div>
        </div>

        <ul
            class="draggable-table"
            style="list-style-type: none; padding: 0px; margin: 0px"
            cdkDropList
            (cdkDropListDropped)="reorderList($event)"
        >
            <li class="draggable-row" *ngFor="let a of anwendungen" cdkDrag>
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="one-row">
                    <p style="width: 34%">{{ a.anwendung }}</p>
                    <p style="width: 10%">{{ a.sortierung }}</p>
                    <p style="width: 10%">QS: {{ a.qs_schluessel }}</p>
                    <p style="width: 10%">HIT: {{ a.hit_schluessel }}</p>
                    <div style="width: 28%">
                        <table style="width: 100%" class="phito-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Tierart</th>
                                    <th>Wartezeit Fleisch</th>
                                    <th>Wartezeit Milch</th>
                                    <th>Wartezeit Eier</th>
                                    <th>Kommentar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let t of a?.tierarten">
                                    <td></td>
                                    <td>{{ t.tierart }}</td>
                                    <td>{{ t.wartezeit_fleisch }}</td>
                                    <td>{{ t.wartezeit_milch }}</td>
                                    <td>{{ t.wartezeit_eier }}</td>
                                    <td>{{ t.kommentar }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="Anwendung Menu"
                        [attr.data-cy]="'maaaa_button_1_0_'"
                    >
                        <mat-icon [attr.data-cy]="'maaaa_mat-icon_3_2_'">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            *kienePermission="[1693]"
                            mat-menu-item
                            (click)="openAnwendungDialog(a)"
                            [attr.data-cy]="'maaaa_button_2_0_'"
                        >
                            <mat-icon [attr.data-cy]="'maaaa_mat-icon_4_2_'">edit</mat-icon>
                            <span [attr.data-cy]="'maaaa_span_3_16_'">Bearbeiten</span>
                        </button>

                        <button
                            *kienePermission="[1694]"
                            mat-menu-item
                            (click)="openDeleteDialog(a)"
                            [attr.data-cy]="'maaaa_button_3_0_'"
                        >
                            <mat-icon [attr.data-cy]="'maaaa_mat-icon_5_2_'">delete</mat-icon>
                            <span [attr.data-cy]="'maaaa_span_4_16_'">L&ouml;schen</span>
                        </button>
                    </mat-menu>
                </div>
            </li>
        </ul>
    </mat-card>
</div>
